import VueRouter from "vue-router"

const routes = [
  { path: '/', redirect: () => { return { path: '/dashboard'}} },
  { path: '/dashboard', component: () => import('../views/DashboardView.vue')},
  { path: '/login', component: () => import('../views/LoginView.vue')},
  { path: '/branches', component: () => import('../views/BranchView.vue')},
  { path: '/indicator-groups', component: () => import('../views/IndicatorGroupView.vue')},
  { path: '/indicators', component: () => import('../views/IndicatorView.vue')},
  { path: '/users', component: () => import('../views/UserView.vue')},
  { path: '*', component: () => import('../views/NotFoundView.vue')}
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');
  if (authRequired && !loggedIn) {
    next({ path: '/login'})
  } else {
    next()
  }
})

export default router